module.exports = __webpack_public_path__ + "images/108_640.jpg";